import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SettingsService } from '../services/settings/settings.service';
import { SidebarService } from '../services/shared/sidebar.service';
import { ModalAppService } from '../components/modal-app/modal-app.service';
import { UserSessionService } from '../services/user/user.service';
import { Router } from '@angular/router';
import { MixpanelService } from '../services/analytics/mixpanel.service';
import { ClientSystemService } from '../services/api-lab4u/client_system.service';
import { PrivateRoutes } from 'src/app/config/config.routes';
import { SeoService } from '../services/seo/seo.service';
import { Subscription } from 'rxjs';
import { User } from '../models/user.model';
import { GeneralDocsService } from '../services/api-lab4u/general-docs.service';
import { mixpanelEvent } from '../config/mixpanel-events';
import { ACTUAL_ENV } from '../config/config';
import { NgClass } from '@angular/common';
import { HeaderComponent } from '../shared/header/header.component';
import { NewsComponent } from '../shared/news/news.component';
import { SidebarComponent } from '../shared/sidebar/sidebar.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { SectionButtonComponent } from '../shared/section-button/section-button.component';
import { AppsCardsListComponent } from '../shared/apps-cards-list/apps-cards-list.component';

/**
 * Declare plugins so then you can run it
 */
declare function init_plugins(): void;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [
    NgClass,
    HeaderComponent,
    NewsComponent,
    SidebarComponent,
    TranslocoDirective,
    SectionButtonComponent,
    AppsCardsListComponent,
  ],
})
export class HomeComponent implements OnInit {
  newsToggleStatus = true;

  /**
   *  @param usergroup Variable that manage the usergroup
   */
  usergroup: string = '';

  user!: User;
  userId = this.clientSystemService.getUserId();

  userEmail = this.UserSessionService.getUserEmail();

  activeEnviroment: string = ACTUAL_ENV;
  /**
   * The loading variable is declare
   * @param loading Variable to show/hide the loading
   */
  loading = true;
  /**
   *
   * @param classroomSection Variable to store the link from private routes to Classrooms
   */
  classroomSection!: string;
  topicsSection!: string;
  trainingQuizzesSection!: string;
  tutorIASection!: string;
  planningSection!: string;

  isTeacher!: boolean;

  teacherSectionTitle!: string;
  studentSectionTitle!: string;

  sidebarElements: any;

  private subscription: Subscription = new Subscription();

  constructor(
    public settings: SettingsService,
    public modalAppService: ModalAppService,
    public UserSessionService: UserSessionService,
    public clientSystemService: ClientSystemService,
    public router: Router,
    public mixpanelService: MixpanelService,
    private seoService: SeoService,
    private title: Title,
    public generalDocsService: GeneralDocsService,
    public sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    init_plugins();
    this.sidebarElements = this.sidebarService.getMenu();

    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      this.user = JSON.parse(storedUser);
      this.usergroup = this.user.actual_deal ?? '';
    } else
      this.UserSessionService.infoUser().subscribe((resp: any) => {
        this.user = resp.user;
        localStorage.setItem('user', JSON.stringify(this.user));
        this.cdr.markForCheck();
      });

    // SEO
    this.title.setTitle('Home');
    this.seoService.generateTags({
      title: 'Home',
      description: '',
      slug: 'dashboard',
    });

    this.classroomSection = PrivateRoutes.CLASSROOMS;
    this.topicsSection = PrivateRoutes.TOPICS;
    this.trainingQuizzesSection = PrivateRoutes.TRAINING_QUIZZES;
    this.tutorIASection = PrivateRoutes.TUTORIA;
    this.planningSection = PrivateRoutes.PLANNING_AI;

    //To validate the user type
    this.isTeacher = this.user.user_type === 'TEACHER';
    //use the name in the i18n en and es
    this.teacherSectionTitle = 'TEACHER-CLASSROOM';
    this.studentSectionTitle = 'STUDENT-CLASSROOM';

    // Execute only after initialization has finished.
    setTimeout(() => {
      this.homeSucceeded();
    }, 0);
  }

  receiveToggleNewsStatus($status: boolean) {
    this.newsToggleStatus = $status;
  }

  homeSucceeded() {
    this.mixpanelService.track(mixpanelEvent.HOME_SHOW_HOME_SUCCEEDED, {
      source_name: mixpanelEvent.SOURCE_NAME,
    });
  }
}
